export default "__VITE_ASSET__CahRk7Mj__"